var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowWTextEng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 342 342",
    style: {
      enableBackground: "new 0 0 342 342"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:50;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#424241;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "svg_arrow_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177,44.6c37,1.8,72.9,19.9,96.1,52.3c40.3,56.4,27.4,134.8-29,175.2s-134.8,27.4-175.2-29 c-21.8-30.3-28.1-67.1-20.3-101"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "84.1,172.2 76.3,87.7 7.1,136.7  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Lager_5_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.2,136.9l18,8.3l-1.1,2.3l-18-8.3L100.2,136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.6,123.4l11.8,5.6c0.7,0.3,1.2,0.6,1.8,0.9l0.1-0.1c-0.8-0.5-1.6-1-2.4-1.5l-1.5-1.1l-7.9-6.1l1.5-1.9 l15.5,12.3l-1.8,2.3l-13.7-6.7l-0.1,0.1l1.4,1l1.4,1l9.2,6.9l-1.5,1.9l-15.5-12.3L108.6,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.3,107.8l9.8,8.6c0.6,0.5,1,0.9,1.5,1.4l0.1-0.1c-0.7-0.7-1.2-1.4-1.9-2.2l-1.1-1.5l-5.9-8.1l2-1.4 l11.6,16.1l-2.4,1.7l-11.3-10.1l-0.1,0.1l1.1,1.3l1.1,1.3l6.9,9.2l-2,1.4l-11.6-16.1L124.3,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.4,103.4c-0.6-1.7-1-2.9-0.5-4.2c0.4-1.2,1.4-2,2.6-2.4c1.1-0.4,2.1-0.5,3.2,0.1c1.4,0.7,1.9,2,2.7,4.3 l3.2,8.9c0.5,1.4,1.6,4.4-2.5,5.9c-0.5,0.2-2.4,0.8-4-0.7c-0.8-0.7-1-1.6-1.4-2.5L142.4,103.4z M147.8,101.3 c-0.5-1.7-1-2.8-2.5-2.4c-0.2,0.1-1.1,0.4-1.1,1.4c0,0.4,0.2,0.8,0.5,1.9l3.6,10.1c0.4,0.9,0.7,2,2.1,1.4 c1.5-0.6,1.1-1.7,0.6-3.1L147.8,101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.5,92.4l2.6-0.1l-1.7,20l-3,0.2L161,93l2.6-0.1l2.3,11.3c0.4,2.2,0.5,2.4,0.7,4.4l0.3,0 c-0.1-1.8-0.1-1.9,0.1-4.6L167.5,92.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M186.8,94l-0.6,20l-2.5-0.4l0.2-3.7l-2.9-0.5l-1.1,3.5l-2.5-0.4l6.3-19.1L186.8,94z M184.4,97.3 c-0.5,2.5-0.6,2.8-0.7,3.1l-2.1,6.5l2.3,0.4l0.2-7c0-0.8,0.1-1.5,0.5-3.1L184.4,97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M199,97.4l8,3.6l-0.9,2.1l-2.8-1.2l-7.1,16l-2.4-1.1l7.1-16l-2.8-1.2L199,97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.2,108.1l-11.7,16l-2.1-1.5l11.7-16L218.2,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M223.7,120c1.4-1.1,2.4-2,3.7-2c1.3,0,2.4,0.6,3.2,1.6c0.8,0.8,1.2,1.8,1.1,3c-0.1,1.5-1.2,2.5-3.1,4.1 l-7.1,6.2c-1.1,0.9-3.6,3-6.4-0.2c-0.4-0.4-1.7-2-0.8-3.9c0.4-1,1.1-1.5,1.8-2.2L223.7,120z M227.6,124.2c1.3-1.1,2.3-2,1.3-3.2 c-0.1-0.2-0.8-0.9-1.6-0.5c-0.4,0.2-0.7,0.5-1.7,1.2l-8.1,7c-0.8,0.7-1.5,1.4-0.5,2.5c1,1.2,2,0.3,3.1-0.5L227.6,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.6,136.7l-10.2,8c-0.6,0.5-1.1,0.8-1.6,1.2l0.1,0.2c0.8-0.5,1.6-1,2.5-1.4l1.7-0.8l9-4.4l1,2.3l-18,8.3 l-1.2-2.6l12.1-9.2l-0.1-0.2l-1.5,0.8l-1.5,0.8l-10.3,5l-1-2.3l18-8.3L241.6,136.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.4,169.2l0.4,4.8c0.2,2.8-1.4,3.2-3,3.3l-13.3,1.1c-2.6,0.2-3.5-0.4-3.7-2.5l-0.4-5.1L112.4,169.2z  M110.1,172L95,173.3l0.1,1.8c0.1,0.8,0.5,0.8,1.2,0.8l12.6-1.1c0.8-0.1,1.4-0.1,1.3-1.2L110.1,172z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.6,186.9L96.4,193l-0.8-2.5l19.1-6.1L115.6,186.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.7,196.8c1.5-0.9,2.5-1.5,3.9-1.4c1.8,0.1,2.7,1.3,3.1,2c1.8,3.1-0.7,4.6-2,5.3l-1.8,1.1l-1.2-2.1 l1.9-1.1c1-0.6,1.7-1.1,1.2-2.1c-0.7-1.2-1.7-0.5-2.6,0l-10,5.8c-1.1,0.7-2.1,1.2-1.4,2.3c0.7,1.2,1.7,0.6,2.2,0.3l3.9-2.3 l-0.8-1.4l2.1-1.2l2.1,3.7l-9.2,5.4l-0.8-1.4l0.7-0.7c-0.6-0.1-1.6-0.2-2.3-1.5c-1.8-3.1,1.2-4.9,2.5-5.7L113.7,196.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.1,208.9l-14.7,13.7l-1.8-1.9l14.7-13.7L129.1,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.5,213.2l7.2,5.1l-1.4,1.9l-2.6-1.8l-10.2,14.5l-2.2-1.6l10.2-14.5l-2.5-1.8L133.5,213.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.2,222.7l-4.7,19.8l-2.4-1l0.9-3.6l-2.8-1.1l-1.8,3.3l-2.4-1l10.1-17.6L150.2,222.7z M147.1,225.5 c-1.1,2.4-1.2,2.7-1.3,3l-3.4,6.1l2.2,0.9l1.7-6.8c0.2-0.8,0.4-1.5,1-3L147.1,225.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.9,225.7l-2.4,17.5l4.3,0.6l-0.3,2.4l-7-1l2.7-19.9L161.9,225.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.3,226.2l1.1,20.1l-2.6,0.1l-1.1-20.1L175.3,226.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.3,223.4l0.4,1.7l-0.4,16.6l4.2-1.1l0.6,2.3l-6.9,1.8l-0.5-1.7l0.5-16.7l-3.5,0.9l-0.6-2.3L189.3,223.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M199.9,218.5l12.4,16.1l-2.3,1.2l-2.2-3l-2.6,1.4l1.4,3.5l-2.2,1.2l-7.2-19L199.9,218.5z M200.2,222.7 c1.2,2.3,1.3,2.6,1.4,2.9l2.6,6.5l2.1-1.1l-4.2-5.6c-0.5-0.6-0.9-1.3-1.7-2.7L200.2,222.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.2,214.5l6.6-5.9l1.6,1.8l-2.3,2.1l11.8,13.2l-2,1.8L210,214.2l-2.3,2L206.2,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.2,201.8l16.1,12l-1.6,2.1l-16.1-12L218.2,201.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M227.3,197.6c-1.7-0.7-2.8-1.3-3.4-2.6c-0.5-1.1-0.5-2.4,0-3.6c0.4-1,1.1-1.9,2.2-2.3c1.5-0.6,2.8,0,5.1,1 l8.7,3.8c1.4,0.6,4.3,1.9,2.6,5.9c-0.2,0.5-1,2.4-3.2,2.5c-1,0.1-1.9-0.3-2.8-0.7L227.3,197.6z M229.4,192.2 c-1.6-0.7-2.8-1.2-3.4,0.2c-0.1,0.2-0.5,1,0.3,1.7c0.3,0.3,0.7,0.5,1.8,1l9.9,4.3c0.9,0.4,2,0.8,2.5-0.6c0.6-1.4-0.6-2-1.9-2.6 L229.4,192.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M228.1,177.8l13.1-1.2c0.8-0.1,1.4-0.1,2-0.2l0-0.2c-0.9,0-1.9,0-2.9-0.1l-1.9-0.1l-10-1.3l0.3-2.5l19.9,2.7 l-0.4,2.9l-15.4,1.2l0,0.2l1.7,0.1l1.7,0.1l11.5,1.3l-0.3,2.5l-19.9-2.7L228.1,177.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWTextEng);
export default __webpack_public_path__ + "static/media/arrow_w_text_ENG.a726d9e2a238ab1cc11eb6746e9cc4f3.svg";
export { ForwardRef as ReactComponent };